/** Shared by the account menu and its "Sign in as" side menu. */
export const menuClass = 'dropdown-menu z-50 border border-ink bg-paper py-2 text-ink shadow-[0_12px_32px_rgb(0_0_0/0.14)]'
export const itemClass =
  'flex w-full cursor-pointer select-none items-center gap-3 px-4 py-2.5 text-left text-small text-charcoal outline-none data-[highlighted]:bg-gray-100 data-[highlighted]:text-ink data-[disabled]:cursor-wait data-[disabled]:opacity-60'
